<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div class="crumbs-box-p">
        <span>匠心记</span>
        <span>&gt;</span>
        <span>创建QE报告</span>
      </div>
      <!-- 主体 -->
      <div class="carate-qe-main-p">
        <h2 class="create-qe-tit-p">创建QE报告</h2>
        <div class="create-title-p">
          <input type="text" placeholder="请输入QE报告的正文标题" v-model="title" />
        </div>

        <div class="create-cover-p" ref="cover">
          <div class="cover-title-p">
            <h3>报告封面</h3>
            <p @click="editCover">
              <span>展开编辑页面</span>
              <img
                :style="{transform:this.rotate}"
                src="../../../../html/pages/originality/createQe/images/open.png"
                alt
              />
            </p>
          </div>
            <div class="cover-main-p" v-if="coverIsShow">
              <image-upload
                :qe='false'
                :multiple="false"
                :src="src1"
                :isOne="true"
                :coverDataArr="oldPostCoverImage"
                @getDataArr="getDataArr"
              >
                <i slot="del" class="del-p"></i>
              </image-upload>
              <textarea placeholder="请输入封面内容" v-model="PostCoverName"></textarea>
            </div>
        </div>

        <edit-box class="quality-edit-p" v-model="qualityScore" ref="quality">
          <span slot="title">质量安全篇编辑</span>
        </edit-box>

        <edit-box class="material-edit-p" title="材料" v-model="materialScore" ref="material">
          <span slot="title">材料安全篇编辑</span>
        </edit-box>

        <div class="qe-btn-p">
          <p>取消</p>
          <p @click="create">创建</p>
        </div>
      </div>

      <aside-right
        @scrollToCover="scrollToCover"
        @scrollToQuality="scrollToQuality"
        @scrollToMaterial="scrollToMaterial"
        @scrollToTop="scrollToTop"
      />
    </div>
  </div>
</template>

<script>
import "../../../../html/pages/originality/createQe/testQE.scss"

import ImageUpload from "../../../../components/imageUpload/ImageUpload"
import editBox from "./components/editBox"
import asideRight from "./components/asideRight"

import { jxjAddQEReport, jxjAddCover, getJxjDetail } from "../../../../api/index"

export default {
  name: 'testQE',
  data() {
    return {
      id: "",
      rotate: '',
      src1: require("../../../../html/pages/originality/createQe/images/upload.jpg"),
      coverIsShow: false,
      qualityScore: [
        { option: "各道工序核验情况", totalScore: 30, score: "" },
        { option: "使用材料检测报告", totalScore: 10, score: "" },
        { option: "现场核验实测数据", totalScore: 20, score: "" },
        { option: "整改建议及复核情况", totalScore: 10, score: "" },
        { option: "现场材料管理情况", totalScore: 10, score: "" },
        { option: "现场人员环境安全情况", totalScore: 10, score: "" },
        { option: "实现途径", totalScore: 10, score: "" },
      ],
      materialScore: [
        { option: "材料放置情况", totalScore: 20, score: "" },
        { option: "材料放置场地合理情况", totalScore: 20, score: "" },
        { option: "现场材料使用情况", totalScore: 30, score: "" },
        { option: "使用未完材料归来情况", totalScore: 20, score: "" },
        { option: "施工方案", totalScore: 30, score: "" },
        { option: "安全交底", totalScore: 30, score: "" },
        { option: "资料", totalScore: 30, score: "" },
        { option: "印章规范使用情况", totalScore: 20, score: "" }
      ],
      title: "",
      PostCoverName: "",
      PostCoverImage: [],
      oldPostCoverImage: [],
    }
  },
  components: {
    ImageUpload,
    editBox,
    asideRight
  },
  methods: {
    editCover() {
      if (!this.rotate) {
        this.rotate = `rotate(0deg)`
      } else {
        this.rotate = ''
      }
      this.coverIsShow = !this.coverIsShow;
    },
    getDataArr(data) {
      this.PostCoverImage = data
      this.oldPostCoverImage = []
    },
    async create() {
      /*
      **数据整合
      */

      // 质量安全的文本和图片
      let Content1 = []
      this.createContent(this.$refs.quality.formList, Content1);

      // 材料安全的文本和图片
      let Content2 = []
      this.createContent(this.$refs.material.formList, Content2);

      // 质量安全的评分
      let QEPoints1 = this.qualityScore.reduce((str, item) => {
        return str + item.score + ","
      }, "").slice(0, -1)

      // 材料安全的评分
      let QEPoints2 = this.materialScore.reduce((str, item) => {
        return str + item.score + ","
      }, "").slice(0, -1)

      // 质量安全节点的文本和图片
      let EQualitySyModel = []
      this.$refs.quality.formList.forEach(item => {
        if (item.type == "node") {
          EQualitySyModel.push({
            NodeName: item.content.nodeName.trim(),
            Remark: item.content.remark.trim(),
            Status: item.content.nodeState,
            ImageJosn: item.content && item.content.img
          })
        }
      })


      /*
      **检测表单数据
      */
      // //qe报告标题
      // if (!this.title) return this.$layer.alert("请填写QE报告标题!")

      // 封面部分
      if (!this.PostCoverName) return this.$layer.alert("请填写封面内容!")
      if (this.PostCoverImage.length == 0 && this.oldPostCoverImage.length == 0) return this.$layer.alert("请上传封面图片!")

      // 质量安全部分
      // 文本内容
      for (let i = 0; i < Content1.length; i++) {
        if (Content1[i].type == 1 && !Content1[i].data) {
          return this.$layer.alert("请填写质量安全内容!")
        }
      }
      // 是否添加节点
      if (EQualitySyModel.length > 0) {
        // 节点详情
        for (let i = 0; i < EQualitySyModel.length; i++) {
          if (!EQualitySyModel[i].NodeName) {
            return this.$layer.alert("请填写节点名称!")
          }
          if (!EQualitySyModel[i].Remark) {
            return this.$layer.alert("请填写节点内容!")
          }
          if (!EQualitySyModel[i].Status) {
            return this.$layer.alert("请选择节点状态!")
          }
        }
      }
      // 评分
      if (!this.$refs.quality.scoreTableIsShow) return this.$layer.alert("请添加质量安全评分")

      // 材料安全部分
      // 文本内容
      for (let i = 0; i < Content2.length; i++) {
        if (Content2[i].type == 1 && !Content2[i].data) {
          return this.$layer.alert("请填写材料安全内容!")
        }
      }
      // 评分
      if (!this.$refs.material.scoreTableIsShow) return this.$layer.alert("请添加材料安全评分")


      let params = {
        userPosts: {
          Name: this.title,
          Content1,
          Content2,
          ForumsId: this.id,
          QEPoints1,
          QEPoints2,
        },
      }

      // 创建修改封面
      if (this.PostCoverImage.length > 0) {
        let coverRes = await jxjAddCover({
          ForumsId: this.id,
          PostCoverName: this.PostCoverName,
          PostCoverImage: this.PostCoverImage.join()
        })
        if (coverRes.Type == 'Error') {
          this.$layer.alert(coverRes.Content);
        }
      }



      // 创建qe报告
      let reportRes = await jxjAddQEReport(params)
      if (reportRes.Type == 'Success') {
        this.$layer.msg(reportRes.Content, (msg) => {
          this.$layer.close(msg)
          this.$router.push({ name: "jxjDetail", params: { id: this.$route.params.id } })
        })
      } else if (reportRes.Type == 'Error') {
        this.$layer.alert(reportRes.Content);
      }
    },
    createContent(targetArr, newArr) {
      targetArr.forEach(item => {
        if (item.type == "text") {
          newArr.push({ type: 1, data: item.content.trim() })
        } else if (item.type == "img") {
          item.content.forEach(img => {
            newArr.push({ type: 2, data: img })
          })
        } else if (item.type == "node") {
          newArr.push({ type: 4, data: JSON.stringify(item.content) })
        }
      })
    },
    scrollToCover() {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.cover.offsetTop - 60
    },
    scrollToQuality() {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.quality.$el.offsetTop - 60
    },
    scrollToMaterial() {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.material.$el.offsetTop - 60
    },
    scrollToTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    async init() {
      let res = await getJxjDetail({
        id: this.id
      })
      if (res.Type == "Success") {
        this.PostCoverName = res.Data.PostCoverName;
        if (res.Data.PostCoverImage) {
          this.oldPostCoverImage = [res.Data.PostCoverImage];
        }
        if (!this.PostCoverName) {
          this.coverIsShow = true
        }
        console.log(res)
      }
    },
  },
  created() {
    this.id = this.$route.params.id
    this.init()
  }
}
</script>

